import { styled } from '@mui/material/styles';

interface StyledPricingCardProps {
  /** Highlights the card (e.g. “Recommended” tier) */
  recommended?: boolean;
}

const StyledPricingCard = styled('div', {
  shouldForwardProp: prop => prop !== 'recommended',
})<StyledPricingCardProps>`
  position: relative;
  box-sizing: border-box;
  width: 100%;
  max-width: 340px;
  min-height: 520px;
  height: 100%;
  flex: 1 1 auto;
  min-width: 0;
  padding: ${({ theme }) => theme.spacing(3)};
  padding-top: ${({ theme, recommended }) =>
    recommended ? theme.spacing(4) : theme.spacing(3)};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border-radius: ${({ theme }) => theme.spacing(2)};
  background-color: ${({ theme }) => theme.palette.background.paper};
  border: 1px solid
    ${({ theme, recommended }) =>
      recommended ? theme.palette.primary.main : theme.palette.divider};
  box-shadow: ${({ theme, recommended }) =>
    recommended
      ? `0 0 0 1px ${theme.palette.primary.main}14, 0 12px 40px -12px rgba(0, 0, 0, 0.12)`
      : '0 1px 3px rgba(0, 0, 0, 0.06)'};
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    border-color 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${({ theme, recommended }) =>
      recommended
        ? `0 0 0 1px ${theme.palette.primary.main}26, 0 16px 48px -16px rgba(0, 0, 0, 0.14)`
        : '0 8px 24px -8px rgba(0, 0, 0, 0.1)'};
  }
`;

export default StyledPricingCard;
